import { render, staticRenderFns } from "./AddHuman.vue?vue&type=template&id=5c04a8c8&scoped=true&"
import script from "./AddHuman.vue?vue&type=script&lang=js&"
export * from "./AddHuman.vue?vue&type=script&lang=js&"
import style0 from "./AddHuman.vue?vue&type=style&index=0&id=5c04a8c8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04a8c8",
  null
  
)

export default component.exports